import { z } from 'zod'

export const MAX_REPORT_PERIOD_DAYS = 365

export const createReportFormSchema = z
  .object({
    dateFrom: z.date({ message: 'Поле не может быть пустым' }),
    dateTo: z.date({ message: 'Поле не может быть пустым' }),
    locale: z.enum(['ru', 'kz']),
    schoolIds: z.array(z.string()).min(1, { message: 'Поле не может быть пустым' }),
    grades: z.array(z.number()),
    classLetters: z.array(z.string()),
  })
  .refine((data) => data.dateTo > data.dateFrom, {
    message: 'Дата окончания должна быть позже даты начала',
    path: ['dateTo'],
  })

export const createNoMealReportFormSchema = createReportFormSchema.refine(
  (data) => {
    const diffMs = data.dateTo.getTime() - data.dateFrom.getTime()
    const diffDays = diffMs / (1000 * 60 * 60 * 24)
    return diffDays <= MAX_REPORT_PERIOD_DAYS
  },
  {
    message: 'Период не может превышать один год',
    path: ['dateTo'],
  }
)
